<main class="container-fluid container-fluid-limited position-relative timeline-main main-page">
    <h1 class="pt-4 pb-3 team-selector">
        <div class="team-selector-label">
            {{'socialView.title' | translate}}
        </div>
        <tm-team-select baseUrl="/timeline" [teamIdFromUrl]="teamId"></tm-team-select>
    </h1>

    <div class="row card-container flex-row-reverse">
        <div class="col-lg-4">
            <div class="mb-2 user-activity">
                @if(!isUserManager){
                    <user-activity (onRequestCreateQuestion)="onOpenCreateQuestionDialog()"
                                    (onRequestCreateIssue)="onOpenCreateIssueDialog()"
                                    (onRequestCreateKudos)="onOpenCreateKudosDialog()"
                                    (onRequestScrollToTimelineItem)="onRequestScrollToTimelineItem($event)"></user-activity>
                }
                
            </div>
        </div>
        <div class="col-lg-8 mb-md-3 position-relative">
            @if(userRequest){
                <user-requests context="timeline"
                               [request]="userRequest"
                               [teamId]="teamId"
                               [author]="author"
                               [teams]="teams"
                               (onRequestCreateQuestion)="onOpenCreateQuestionDialog()"
                               (onRequestCreateIssue)="onOpenCreateIssueDialog()"
                               (onRequestCreateKudos)="onOpenCreateKudosDialog()"
                               (onRequestCreatePoll)="onOpenCreatePollDialog()"
                               (onCreateTimelineItemAfterRequest)="onCreateTimelineItemAfterRequest($event)"></user-requests>
            }

            <div class="sort-menu mt-2 mt-md-0">
                <button class="btn btn-secondary filter-btn mt-1" [matMenuTriggerFor]="menu">
                    <i class="fa-light fa-sort pe-1"></i>{{'timeline.filter' | translate}}
                </button>
                <mat-menu #menu="matMenu">
                    @for (option of filterOptions; track $index) {
                        <button mat-menu-item (click)="selectFilter(option.id)">{{option.label| translate}}</button>
                    }
                </mat-menu>
              </div>
            
            <div tm-infinite-scroll (nearEnd)="loadMore()" [infiniteScrollDisabled]="busy || noMoreItems">
                @for(day of days; track day.nativeDate){
                    @if(day.values.length > 0){
                    <tm-daily-overview
                                    class="daily-overview dayElt mb-2 pb-4 mt-2"
                                    [filterOption]="filterOption"
                                    [day]="day"
                                    [teamId]="teamId"
                                    [userInfos]="userInfos"
                                    (updateUserRequest)="onDeleteOrModerateItem()"></tm-daily-overview>
                    }
                }

                @if(busy){
                <div class="text-center pt-4"><i class="far fa-spinner fa-spin fa-2x fa-fw"></i></div>
                }
            </div>

            <tm-empty-timeline [isTimelineEmpty]="days?.length === 0"></tm-empty-timeline>
        </div>
    </div>

    <div class="btn btn-default btn-sm hide-for-mobile"
         id="scrollToTopBtn"
         [style.display]="showScrollToTopBtn"
         (click)="scrollToTop()"
         title="{{ 'day-navigation.go-top' | translate }}"><i class="fa-solid fa-up-to-line"></i></div>

</main>